import './App.css';
import Header from './component/Header';
import TinderCards from './component/TinderCards';
import Footer from './component/Footer';


function App() {
  return (
    <>
      
      <Header />
      
      <TinderCards />
      
      <Footer />
    </>
  );
}

export default App;
